/* Mood board maker (mobile). See sections/dw-mood-board.liquid */
(() => {
  const cfg = window.DW_MOOD || {};
  const root = document.querySelector('[data-mood]');
  const openBtn = document.querySelector('[data-mood-open]');
  if (!root || !openBtn) return;
  document.body.appendChild(root);

  const KEY = 'dw_moodboard_v1';
  const board = root.querySelector('[data-board]');
  const titleEl = root.querySelector('[data-board-title]');
  const emptyEl = root.querySelector('[data-board-empty]');
  const tools = root.querySelector('[data-tools]');
  const tray = root.querySelector('[data-tray]');
  const tabsEl = root.querySelector('[data-tabs]');
  const bgsEl = root.querySelector('[data-bgs]');
  const cartBtn = root.querySelector('[data-mood-cart]');

  const money = (c) => '₹' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: c % 100 ? 2 : 0 });
  const shortName = (t) =>
    t.replace(/^Miniature\s+/i, '').replace(/\s*Assorted.*$/i, '').replace(/\s*\(\d+\s*pcs?\)\s*$/i, '').trim();

  // Backgrounds: css for the board, draw() for the saved picture
  const BGS = [
    { id: 'sunny', name: 'Sunny', css: '#faed17', ink: '#111', draw: (c, w, h) => fill(c, w, h, '#faed17') },
    { id: 'blush', name: 'Blush', css: '#ffd9e4', ink: '#111', draw: (c, w, h) => fill(c, w, h, '#ffd9e4') },
    { id: 'mint', name: 'Mint', css: '#cdf3e3', ink: '#111', draw: (c, w, h) => fill(c, w, h, '#cdf3e3') },
    {
      id: 'sky', name: 'Sky', css: 'linear-gradient(180deg,#9fd8ff 0%,#e8f6ff 100%)', ink: '#111',
      draw: (c, w, h) => {
        const g = c.createLinearGradient(0, 0, 0, h);
        g.addColorStop(0, '#9fd8ff');
        g.addColorStop(1, '#e8f6ff');
        c.fillStyle = g;
        c.fillRect(0, 0, w, h);
      },
    },
    {
      id: 'dots', name: 'Dots', css: 'radial-gradient(#e52227 18%, transparent 20%) 0 0 / 22px 22px, #fff6e6', ink: '#111',
      draw: (c, w, h) => {
        fill(c, w, h, '#fff6e6');
        c.fillStyle = '#e52227';
        const step = w / 20;
        for (let y = step / 2; y < h; y += step) for (let x = step / 2; x < w; x += step) {
          c.beginPath();
          c.arc(x, y, step * 0.18, 0, Math.PI * 2);
          c.fill();
        }
      },
    },
    {
      id: 'grid', name: 'Grid', ink: '#111',
      css: 'linear-gradient(#d9e6f5 1px, transparent 1px) 0 0 / 20px 20px, linear-gradient(90deg, #d9e6f5 1px, transparent 1px) 0 0 / 20px 20px, #fff',
      draw: (c, w, h) => {
        fill(c, w, h, '#fff');
        c.strokeStyle = '#d9e6f5';
        c.lineWidth = 2;
        const step = w / 20;
        for (let x = 0; x <= w; x += step) line(c, x, 0, x, h);
        for (let y = 0; y <= h; y += step) line(c, 0, y, w, y);
      },
    },
    {
      id: 'night', name: 'Night', ink: '#fff',
      css: 'radial-gradient(circle at 20% 15%, #fff 1px, transparent 2px) 0 0 / 60px 60px, radial-gradient(circle at 70% 60%, #fff9 1px, transparent 2px) 0 0 / 45px 45px, #1b1340',
      draw: (c, w, h) => {
        fill(c, w, h, '#1b1340');
        c.fillStyle = 'rgba(255,255,255,.8)';
        for (let i = 0; i < 140; i++) {
          c.beginPath();
          c.arc((i * 97.3) % w, (i * 57.7 * 1.7) % h, (i % 3) + 1.2, 0, Math.PI * 2);
          c.fill();
        }
      },
    },
  ];
  function fill(c, w, h, col) {
    c.fillStyle = col;
    c.fillRect(0, 0, w, h);
  }
  function line(c, a, b, x, y) {
    c.beginPath();
    c.moveTo(a, b);
    c.lineTo(x, y);
    c.stroke();
  }

  // ── State ───────────────────────────────────────────────
  let products = {}; // handle → product
  let state = { bg: 'sunny', title: 'My Mini World ✨', items: [] }; // items: {uid, handle, x, y, w, r, f, z}
  let selected = null;
  let zTop = 1;
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (saved && Array.isArray(saved.items)) state = Object.assign(state, saved);
  } catch (e) {}
  const persist = () => {
    try {
      localStorage.setItem(KEY, JSON.stringify(state));
    } catch (e) {}
  };

  // ── Rendering ───────────────────────────────────────────
  function applyBg() {
    const bg = BGS.find((b) => b.id === state.bg) || BGS[0];
    board.style.background = bg.css;
    board.style.setProperty('--ink', bg.ink);
    bgsEl.querySelectorAll('button').forEach((b) => b.setAttribute('aria-checked', String(b.dataset.bg === bg.id)));
  }

  function place(el, it) {
    el.style.left = it.x * 100 + '%';
    el.style.top = it.y * 100 + '%';
    el.style.width = it.w * 100 + '%';
    el.style.zIndex = it.z;
    el.style.transform = `translate(-50%, -50%) rotate(${it.r}deg) scaleX(${it.f})`;
  }

  function renderItems() {
    board.querySelectorAll('.dw-mood__item').forEach((n) => n.remove());
    state.items.forEach((it) => {
      const p = products[it.handle];
      const src = (p && p.img) || (cfg.cutouts || {})[it.handle];
      if (!src) return;
      zTop = Math.max(zTop, it.z);
      const el = document.createElement('div');
      el.className = 'dw-mood__item' + (selected === it.uid ? ' is-selected' : '');
      el.dataset.uid = it.uid;
      el.innerHTML = `<img src="${src}" alt="" draggable="false" crossorigin="anonymous">`;
      place(el, it);
      board.appendChild(el);
    });
    emptyEl.hidden = state.items.length > 0;
    tools.classList.toggle('is-active', !!selected);
    updateCart();
  }

  function select(uid) {
    selected = uid;
    board.querySelectorAll('.dw-mood__item').forEach((n) => n.classList.toggle('is-selected', n.dataset.uid === uid));
    tools.classList.toggle('is-active', !!uid);
  }

  function updateCart() {
    const counts = {};
    let total = 0;
    state.items.forEach((it) => {
      const p = products[it.handle];
      if (!p) return;
      counts[p.variantId] = (counts[p.variantId] || 0) + 1;
      total += p.price;
    });
    const n = Object.values(counts).reduce((a, b) => a + b, 0);
    cartBtn.disabled = n === 0;
    cartBtn.textContent = n ? `Add ${n} mini${n > 1 ? 's' : ''} to cart · ${money(total)}` : 'Add minis to cart';
    return counts;
  }

  // ── Tray ────────────────────────────────────────────────
  let activeTab = 0;
  function renderTray() {
    const src = (cfg.sources || [])[activeTab];
    const list = Object.values(products).filter((p) => p.source === (src && src[0]));
    tabsEl.querySelectorAll('button').forEach((b, i) => b.setAttribute('aria-selected', String(i === activeTab)));
    tray.innerHTML = list.length
      ? list
          .map(
            (p) => `<button type="button" class="dw-mood__mini" data-add="${p.handle}" aria-label="Add ${p.name}">
              <span class="dw-mood__mini-img"><img src="${p.img}" alt="" loading="lazy"></span>
              <span class="dw-mood__mini-name">${p.name}</span>
              <span class="dw-mood__mini-price">${money(p.price)}</span>
            </button>`
          )
          .join('')
      : '<p class="dw-mood__loading">No minis here right now.</p>';
  }

  function addItem(handle) {
    const n = state.items.length;
    const it = {
      uid: Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
      handle,
      x: 0.5 + ((n % 5) - 2) * 0.08,
      y: 0.55 + ((Math.floor(n / 5) % 3) - 1) * 0.1,
      w: 0.3,
      r: ((n % 3) - 1) * 6,
      f: 1,
      z: ++zTop,
    };
    state.items.push(it);
    selected = it.uid;
    persist();
    renderItems();
  }

  // ── Board gestures: drag, pinch-resize, twist-rotate ─────
  const pointers = new Map();
  let gesture = null;
  const rect = () => board.getBoundingClientRect();
  const itemOf = (uid) => state.items.find((i) => i.uid === uid);

  board.addEventListener('pointerdown', (e) => {
    if (e.target.closest('[data-board-title]')) return;
    const el = e.target.closest('.dw-mood__item');
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    board.setPointerCapture(e.pointerId);
    if (pointers.size === 1) {
      if (!el) {
        select(null);
        gesture = null;
        return;
      }
      select(el.dataset.uid);
      const it = itemOf(el.dataset.uid);
      gesture = { mode: 'drag', it, el, sx: e.clientX, sy: e.clientY, ox: it.x, oy: it.y };
    } else if (pointers.size === 2 && selected) {
      const it = itemOf(selected);
      const el = board.querySelector(`[data-uid="${selected}"]`);
      const [a, b] = [...pointers.values()];
      gesture = {
        mode: 'pinch', it, el,
        d0: Math.hypot(b.x - a.x, b.y - a.y), a0: Math.atan2(b.y - a.y, b.x - a.x), w0: it.w, r0: it.r,
      };
    }
  });

  board.addEventListener('pointermove', (e) => {
    if (!pointers.has(e.pointerId) || !gesture) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    const r = rect();
    const g = gesture;
    if (g.mode === 'drag' && pointers.size === 1) {
      g.it.x = Math.min(1, Math.max(0, g.ox + (e.clientX - g.sx) / r.width));
      g.it.y = Math.min(1, Math.max(0, g.oy + (e.clientY - g.sy) / r.height));
    } else if (g.mode === 'pinch' && pointers.size === 2) {
      const [a, b] = [...pointers.values()];
      const d = Math.hypot(b.x - a.x, b.y - a.y);
      const ang = Math.atan2(b.y - a.y, b.x - a.x);
      g.it.w = Math.min(0.9, Math.max(0.08, g.w0 * (d / g.d0)));
      g.it.r = g.r0 + ((ang - g.a0) * 180) / Math.PI;
    }
    place(g.el, g.it);
  });

  const endPointer = (e) => {
    if (!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    if (gesture) persist();
    if (pointers.size === 0) gesture = null;
    else if (pointers.size === 1 && gesture && gesture.mode === 'pinch') {
      const [p] = [...pointers.values()];
      gesture = { mode: 'drag', it: gesture.it, el: gesture.el, sx: p.x, sy: p.y, ox: gesture.it.x, oy: gesture.it.y };
    }
  };
  board.addEventListener('pointerup', endPointer);
  board.addEventListener('pointercancel', endPointer);

  tools.addEventListener('click', (e) => {
    const t = e.target.closest('[data-tool]');
    const it = selected && itemOf(selected);
    if (!t || !it) return;
    const tool = t.dataset.tool;
    if (tool === 'smaller') it.w = Math.max(0.08, it.w * 0.85);
    if (tool === 'bigger') it.w = Math.min(0.9, it.w * 1.18);
    if (tool === 'left') it.r -= 15;
    if (tool === 'right') it.r += 15;
    if (tool === 'flip') it.f *= -1;
    if (tool === 'front') it.z = ++zTop;
    if (tool === 'delete') {
      state.items = state.items.filter((i) => i !== it);
      selected = null;
    }
    persist();
    renderItems();
  });

  titleEl.addEventListener('input', () => {
    state.title = titleEl.textContent.slice(0, 40);
    persist();
  });
  titleEl.addEventListener('keydown', (e) => e.key === 'Enter' && (e.preventDefault(), titleEl.blur()));

  tray.addEventListener('click', (e) => {
    const b = e.target.closest('[data-add]');
    if (b) addItem(b.dataset.add);
  });

  root.querySelector('[data-mood-clear]').addEventListener('click', (e) => {
    const btn = e.currentTarget;
    if (!state.items.length) return;
    if (btn.dataset.confirm !== '1') {
      btn.dataset.confirm = '1';
      btn.textContent = 'Sure?';
      setTimeout(() => {
        btn.dataset.confirm = '';
        btn.textContent = 'Clear';
      }, 2500);
      return;
    }
    btn.dataset.confirm = '';
    btn.textContent = 'Clear';
    state.items = [];
    selected = null;
    persist();
    renderItems();
  });

  // ── Save as picture ─────────────────────────────────────
  const loadImg = (src) =>
    new Promise((res, rej) => {
      const i = new Image();
      i.crossOrigin = 'anonymous';
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = src;
    });

  async function savePicture(btn) {
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Saving…';
    try {
      const W = 1080, H = 1350;
      const cv = document.createElement('canvas');
      cv.width = W;
      cv.height = H;
      const c = cv.getContext('2d');
      const bg = BGS.find((b) => b.id === state.bg) || BGS[0];
      bg.draw(c, W, H);
      const items = state.items.slice().sort((a, b) => a.z - b.z);
      for (const it of items) {
        const p = products[it.handle];
        const img = await loadImg((p && p.img) || cfg.cutouts[it.handle]);
        const dw = it.w * W;
        const dh = dw * (img.naturalHeight / img.naturalWidth);
        c.save();
        c.translate(it.x * W, it.y * H);
        c.rotate((it.r * Math.PI) / 180);
        c.scale(it.f, 1);
        c.drawImage(img, -dw / 2, -dh / 2, dw, dh);
        c.restore();
      }
      c.fillStyle = bg.ink;
      c.textAlign = 'center';
      c.font = '800 64px Poppins, system-ui, sans-serif';
      c.fillText(state.title || '', W / 2, 110, W - 80);
      c.font = '600 30px Poppins, system-ui, sans-serif';
      c.globalAlpha = 0.7;
      c.textAlign = 'right';
      c.fillText('made at dawbu.com', W - 36, H - 36);
      c.globalAlpha = 1;

      const blob = await new Promise((r) => cv.toBlob(r, 'image/png'));
      const file = new File([blob], 'dawbu-mood-board.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: state.title || 'My Dawbu mood board' }).catch(() => {});
      } else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'dawbu-mood-board.png';
        document.body.appendChild(a);
        a.click();
        setTimeout(() => (URL.revokeObjectURL(a.href), a.remove()), 1000);
      }
    } catch (e) {
      alert('Sorry, the picture could not be saved. Please try again.');
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  }
  root.querySelector('[data-mood-save]').addEventListener('click', (e) => savePicture(e.currentTarget));

  // ── Add everything on the board to the cart ─────────────
  cartBtn.addEventListener('click', async () => {
    const counts = updateCart();
    const items = Object.entries(counts).map(([id, quantity]) => ({ id: Number(id), quantity }));
    if (!items.length) return;
    const label = cartBtn.textContent;
    cartBtn.disabled = true;
    cartBtn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'Could not add to cart');
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) {
        const inner = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      cartBtn.textContent = 'Added to cart ✓';
      setTimeout(() => {
        close();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: items[0].id, sections: data.sections });
        }
        cartBtn.textContent = label;
        cartBtn.disabled = false;
      }, 700);
    } catch (e) {
      cartBtn.textContent = e.message || 'Could not add to cart';
      setTimeout(() => {
        cartBtn.textContent = label;
        cartBtn.disabled = false;
      }, 2500);
    }
  });

  // ── Open / close + data loading ─────────────────────────
  let loaded = false;
  async function loadProducts() {
    if (loaded) return;
    loaded = true;
    const cut = cfg.cutouts || {};
    await Promise.all(
      (cfg.sources || []).map(async ([handle, label]) => {
        try {
          const data = await (await fetch(`/collections/${encodeURIComponent(handle)}/products.json?limit=250`)).json();
          (data.products || []).forEach((p) => {
            const v = (p.variants || []).find((x) => x.available);
            if (!v || !cut[p.handle] || products[p.handle]) return;
            products[p.handle] = {
              handle: p.handle, source: handle, tag: label, name: shortName(p.title),
              price: Math.round(parseFloat(v.price) * 100), variantId: v.id, img: cut[p.handle],
            };
          });
        } catch (e) {}
      })
    );
    renderTray();
    renderItems();
  }

  function open() {
    // Shopify's preview bar (theme previews only) covers the bottom buttons
    const pbar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    root.style.paddingBottom = pbar ? pbar.getBoundingClientRect().height + 'px' : '';
    root.hidden = false;
    document.body.classList.add('dw-mood-open');
    requestAnimationFrame(() => root.classList.add('is-open'));
    loadProducts();
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('dw-mood-open');
    select(null);
    setTimeout(() => (root.hidden = true), 250);
  }
  openBtn.addEventListener('click', open);
  root.querySelector('[data-mood-close]').addEventListener('click', close);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && !root.hidden && close());

  // Static UI
  bgsEl.innerHTML = BGS.map(
    (b) => `<button type="button" role="radio" data-bg="${b.id}" aria-label="${b.name}" style="background:${b.css}"></button>`
  ).join('');
  bgsEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bg]');
    if (!b) return;
    state.bg = b.dataset.bg;
    persist();
    applyBg();
  });
  tabsEl.innerHTML = (cfg.sources || [])
    .map((s, i) => `<button type="button" role="tab" data-tab="${i}">${s[1]}</button>`)
    .join('');
  tabsEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tab]');
    if (!b) return;
    activeTab = Number(b.dataset.tab);
    renderTray();
  });
  titleEl.textContent = state.title;
  applyBg();
})();
